import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { clientSideLinks } from '../clientRoutes';
import CardIcon from '../../../shared/components/icons/CardIcon';

function ClientMessagesPage() {
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="flex items-center gap-3 text-2xl font-bold text-navy"><CardIcon name="message" className="h-6 w-6" />Messages</h1>
        <p className="mt-2 text-sm text-slate-600">Manage conversations with workers and applicants.</p>
      </div>
    </DashboardShell>
  );
}

export default ClientMessagesPage;
